export const IndexRoutes = [
  {
    path: '/',
    alias: ['/:preview?'],
    name: 'Index',
    component:  () => {
      return import('@pages/standard-list/index.vue')
    },
    meta: {
      title: '首页',
    },
  },
]


